import React, { Fragment, useEffect } from "react";
import { BrowserRouter, Route, Redirect, Switch, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux'
// pages
import Index from "views/Index.js";
// others
import Login from "../components/Login/Login"
import CustomPage from "../views/CustomPage";
import DetailOneNew from "../views/News/DetailOneNew"
import AllNews from "../views/News/AllNews";
import Category from "../views/Student/StudentExchange";
import DetailCategory from "../views/Student/DetailCategory";
import IndexNavbar from "../components/Navbars/IndexNavbar.js";
import DemoFooter from "../components/Footers/DemoFooter.js";
import ListDetailResearch from "../views/Elements/ListReasearch/ListDetailResearch"
import ListDetailPatent from "../views/Elements/ListReasearch/ListDetailPatent"
import ResearchGroup from "../views/Elements/ResearchGroup";
import Partner from "../views/Elements/Partner"

import Sidebar from '../components/Navbars/Sidebar'
import Breadcrumbs from '../components/BreadCrumbs/Breadcrumbs'
import { Container, Row, Col } from 'reactstrap'
import CloseSubmenu from '../utils/CloseSubmenu'
import BackTop from '../utils/BackTop'
import IndexHeader from '../components/Headers/IndexHeader'
import ImageBackground from '../components/Headers/ImageBackground'
import Media from "../views/Media";
import Student from "../views/Student";
import StudentExchange from "../views/Student/StudentExchange";
import ListImage from "../views/Media/ListImage";
import StudentClub from "../views/Student/StudentClub"
import StudentClubOverview from "../views/Student/StudentClubOverview"
import StudentContest from "../views/Student/StudentContest"
import ListImageStudent from "../views/Student/ListImageStudent";
import LecturerDetail from "views/Lecturers/LecturerDetail";
import StudentLife from "views/Student/StudentLife";
import { CareerOpportunities } from "views/Student/CareerOpportunities";
import { useIntl } from 'react-intl'; // ✅ Thêm useIntl

//KVTT
import Homepage from "views/KVTT/Homepage";

import ConferenceWorkshopList from "../views/ConferenceWorkshopList";
import EventDetail from "../views/ConferenceWorkshopList/EventDetail";
import BrandIdentity from "../views/Media/BrandIdentity";

export default function Router() {
  const location = useLocation() // ⬅️ Đây là hook chính xác từ React Router

  const storeInfo = useSelector(state => state.menu)
   const intl = useIntl();
      const pathSplit = window.location.pathname.split('/')
    const lang = pathSplit[1]
    const isFullWidthPage = location.pathname.includes('/conference-workshop') || location.pathname.includes('/brand-identity');
  useEffect(() => {
    // Thay đổi tiêu đề khi location hoặc ngôn ngữ thay đổi
    document.title = intl.formatMessage({ id: 'pageTitle' })
  }, [location.pathname, intl])

  return (
      <>
        <IndexNavbar />
        <CloseSubmenu />
        <Switch>
          {/* <Route path="/login" exact render={(props) => <Login {...props} />} />
          <Route path="/" exact render={(props) => localStorage.getItem('login') ? <Index {...props} /> : <Redirect to={{ pathname: '/login' }} />} /> */}
          <Route
            path="/"
            exact render={(props) => <Index {...props} />}
          />
           <Route
            path="/vi"
            exact render={(props) => <Index {...props} />}
          />
          <Route
            path="/kvtt/:id"
            render={(props) => <Homepage {...props} />}
          />
          <Route
            path="/researchgroup/:id"
            render={(props) => <ResearchGroup {...props} />}
          />
          <Route
            path="/vi/researchgroup/:id"
            render={(props) => <ResearchGroup {...props} />}
          />
          <Route
            path="/media"
            render={(props) => <Media {...props} />}
          />
          <Route
            path="/lecturer"
            render={(props) => <LecturerDetail {...props} />}
          />

          <Route
            path="/student"
            render={(props) => <Student {...props} />}
          />
          <Route
            path="/life"
            render={(props) => <StudentLife {...props} />}
          />
          <Route
            path="/exchange"
            render={(props) => <StudentExchange {...props} />}
          />
          <Route
            path="/career"
            render={(props) => <CareerOpportunities {...props} />}
          />
          <Route
            path="/club"
            render={(props) => <StudentClub {...props} />}
          />
          <Route
            path="/clubs/overview"
            render={(props) => <StudentClubOverview {...props} />}
          />
          <Route
            path="/categorydetail/detail/:id/:type"
            render={(props) => <DetailCategory {...props} />}
          />

          <Fragment>
            <ImageBackground height={500} imgSrc={storeInfo.image} />
            <div style={{ backgroundColor: '#fff', minHeight: '600px' }}>
              <Container>
                <Row className="wp-rowCustompage">
                  <Col md={isFullWidthPage ? 12 : 9} sm={12} className="wp-custompage">
                    <Breadcrumbs></Breadcrumbs>
                    <div className="d-sidebar-none">
                      <Sidebar></Sidebar>
                    </div>
                    <Route
                      path="/page/:text"
                      render={(props) => <CustomPage {...props} />}
                    />
                    <Route
                      path="/conference-workshop/:id"
                      render={(props) => <EventDetail {...props} />}
                    />
                    <Route
                      path="/conference-workshop"
                      exact
                      render={(props) => <ConferenceWorkshopList {...props} />}
                    />
                    <Route
                      path="/brand-identity"
                      render={(props) => <BrandIdentity {...props} />}
                    />
                    <Route
                      path="/vi/conference-workshop/:id"
                      render={(props) => <EventDetail {...props} />}
                    />
                    <Route
                      path="/vi/conference-workshop"
                      exact
                      render={(props) => <ConferenceWorkshopList {...props} />}
                    />
                     <Route
                      path="/vi/page/:text"
                      render={(props) => <CustomPage {...props} />}
                    />
                    <Route
                      path="/listnews/detail/:id"
                      render={(props) => <DetailOneNew {...props} />}
                    />
                     <Route
                      path="/vi/listnews/detail/:id"
                      render={(props) => <DetailOneNew {...props} />}
                    />
                    <Route
                      path="/news/:cate/:search?"
                      render={(props) => <AllNews {...props} />}
                    />
                     <Route
                      path="/vi/news/:cate/:search?"
                      render={(props) => <AllNews {...props} />}
                    />
                    {/* <Route
                      path="/news/:cate"
                      render={(props) => <AllNews {...props} />}
                    /> */}
                    <Route
                      path="/research/list"
                      render={(props) => <ListDetailResearch {...props} />}
                    />
                    <Route
                      path="/patent/list"
                      render={(props) => <ListDetailPatent {...props} />}
                    />
                    <Route
                      path="/partner/list"
                      render={(props) => <Partner {...props} />}
                    />
                    <Route
                      path="/list/image/:id?"
                      render={(props) => <ListImage {...props} />}
                    />
                    <Route
                      path="/careerAndContest/contest/:id?"
                      render={(props) => <StudentContest {...props} />}
                    />
                    <Route
                      path="/list/imageStudent/:id?"
                      render={(props) => <ListImageStudent {...props} />}
                    />
                  </Col>
                  {!isFullWidthPage && (
                    <Col md={3} sm={12} className="">
                      <Sidebar></Sidebar>
                    </Col>
                  )}
                </Row>
              </Container>
            </div>
          </Fragment>
          {/* <Redirect to="/" /> */}

        </Switch>
        <DemoFooter />
        <BackTop />
      </>
  )
}